<template>
  <div>
    <modal
      name="team-incident"
      :adaptive="true"
      :minHeight="500"
      :maxHeight="auto"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Add New Incident - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="addNewIncident">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-4 xl:mb-0 px-2">
              <multiselect 
              v-model="selectedIncidents"
              ref="multiselect"
              :custom-label="incident"
              track-by="number" 
              placeholder="Select at least one incident" 
              :multiple="true" 
              :options="incidents" 
              :close-on-select="true" 
              :clear-on-select="false" 
              :preserve-search="true" 
              :allow-empty="false" 
              :loading="true"
              >
                <template slot="selection" slot-scope="{ isOpen }">
                  <span class="multiselect__single" v-if="selectedIncidents.length &amp;&amp; !isOpen">{{ selectedIncidents.length }} options selected</span>
                </template>
              </multiselect>
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 absolute inset-x-0 bottom-0 right-0 h-16">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Add"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamIncidentAssign
  Description: This class representing a team incident assign modal.
*/

/* Imports */
import IncidentService from "@/services/incident.service";
import TeamService from "@/services/team.service";
import Multiselect from 'vue-multiselect';
/* /Imports/ */

export default {
  /* 
    Define data with custom incidents state values. 
  */
  data() {
    return {
      incidents: [],
      selectedIncidents: [],
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    Multiselect
  },

  /* 
    Define props from which we got team data. 
  */
  props: {
    team: null
  },
  
  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call IncidentService class to obtain all incidents data.
    */
    getIncidents() {
      IncidentService.getAllIncidents().then((response) => {
        this.incidents = response.incidents;
      });
    },

    /* 
      Format incident in multiselect dropdown.
    */
    incident({ number, state}) {
      return `INC00${number} - ${state}`;
    },

    /* 
      Call TeamService class to add assigned incident to the certain team.
    */
    addNewIncident() {
      var data = { incidents: this.selectedIncidents.map((incident) => incident.id)};
        
      TeamService.assignIncident(this.team.id, data).then(() => {
        location.reload();
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated and load all incidents after the instance.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }

    this.getIncidents();
  },
};
</script>
